// A clear center, curved bevel, and directional rim shared by glass controls.
export default function LiquidGlass() {
  return (
    <span className="liquid-glass" aria-hidden="true">
      <span className="glass-fill" />
      <span className="glass-edge-light" />
      <span className="glass-inner-glow" />
    </span>
  );
}
